import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZWaveComponent } from './simple-icons-z-wave.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZWaveComponent ],
    exports:      [ SimpleIconsZWaveComponent ],
    bootstrap:    []
})
export class SimpleIconsZWaveModule {}
